import { render } from "./PgFooter.vue?vue&type=template&id=417b5f55&scoped=true"
import script from "./PgFooter.vue?vue&type=script&lang=js"
export * from "./PgFooter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mfeys/Desktop/HAv2/studio-vue/18104-braun/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417b5f55"]])

export default __exports__